import { Component, Input, ChangeDetectionStrategy, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

export interface BannerData {
  message: string;
  type: 'warning' | 'info' | 'success';
  dismissalKey: string;
  closeButtonText?: string;
}

@Component({
  selector: 'app-notice-banner',
  templateUrl: './notice-banner.component.html',
  styleUrls: ['./notice-banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoticeBannerComponent implements OnInit, OnDestroy {
  @Input() data: BannerData;
  bannerVisible = false;
  private isDismissing = false;
  private showBannerTimeout: any;

  constructor(private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (!this.isValidData()) {
      return;
    }
    // Check dismissal state on component load
    if (!this.isDismissed()) {
      this.bannerVisible = true;
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy(): void {
    if (this.showBannerTimeout) {
      clearTimeout(this.showBannerTimeout);
    }
  }

  private isValidData(): boolean {
    return this.data &&
      typeof this.data.message === 'string' &&
      this.data.message.trim().length > 0 &&
      ['warning', 'info', 'success'].includes(this.data.type) &&
      typeof this.data.dismissalKey === 'string' &&
      this.data.dismissalKey.trim().length > 0;
  }

  dismissBanner(): void {
    // Prevent multiple rapid dismiss clicks
    if (this.isDismissing) {
      return;
    }

    this.isDismissing = true;
    this.bannerVisible = false;
    this.cdr.markForCheck();

    try {
      localStorage.setItem(this.data.dismissalKey, 'true');
    } catch (error) {
      console.warn('Failed to persist banner dismissal:', error);
    }
  }

  isDismissed(): boolean {
    try {
      if (localStorage.getItem(this.data.dismissalKey) === 'true') {
        return true;
      }
      else {
        localStorage.setItem(this.data.dismissalKey, 'false');
      }
      return false;
    } catch (error) {
      console.warn('Failed to read banner dismissal state:', error);
      return false;
    }
  }
}
